import { render, staticRenderFns } from "./bin-edit.vue?vue&type=template&id=0138f4de&"
import script from "./bin-edit.vue?vue&type=script&lang=js&"
export * from "./bin-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports